import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiChamiliElafron';
const args = {};

export class PetastiChamiliElafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
